import axios, { AxiosInstance } from "axios";
import { store } from "@services/StateManagement/Store";
import { MapContact } from "./MapData";

export const apiPrefix: string = import.meta.env.VITE_API_PREFIX;

export const api: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_SYS_API_URL,
});

export const createQuery = (baseUrl: string, params: Record<string, any>) => {
  const queryString = Object.entries(params)
    .filter(([key, value]) => value !== undefined && value !== null)
    .map(([key, value]) => {
      if (typeof value === "string" && value.includes("=")) {
        return value;
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })
    .join("&");

  const finalUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl;

  return finalUrl;
};

type ApiCallParams = {
  method?: "get" | "post" | "put" | "delete";
  url: string;
  data?: any;
  useToken?: boolean;
  idReturn?: boolean;
  onSuccess?: (response: any) => any;
  onError?: (errorResponse: any) => void;
  setLoading?: (loading: boolean) => void;
};

export const apiCall = async ({
  method = "get",
  url,
  data = {},
  useToken = false,
  idReturn = false,
  onSuccess,
  onError,
  setLoading,
}: ApiCallParams) => {
  let responseMessage;
  let responseId;
  setLoading && setLoading(true);

  try {
    const header = store.getState().api.headers;
    api.defaults.headers = header;

    const response = await api({
      method,
      url: useToken ? `${apiPrefix}/users/myUser` : url,
      data,
    });

    if (onSuccess) {
      responseMessage = onSuccess(response);

      if (idReturn) {
        responseId = response.data?.id;
        response.data?.user_id;
        response.data?.created_users?.id ??
          response.data?.created_users?.[0]?.user?.id ??
          response.data?.created_users?.[0]?.id ??
          response.data?.created_users?.user?.id;
      }
    }
  } catch (err) {
    let errorResponse;
    if (err.response?.data?.duplicate_users) {
      const duplicateUsers =
        err.response?.data?.duplicate_users.map(MapContact);
      responseMessage = {
        type: err.response?.data?.type,
        status: err.status,
        message: err.response?.data?.error,
        duplicate_users: duplicateUsers,
      };
      errorResponse = err.response?.data?.error;
    } else {
      errorResponse =
        err.response?.data?.failed_users?.error ??
        err.response?.data?.failed_users?.[0]?.error ??
        err.response?.data?.failures?.[0]?.error ??
        err.response?.data?.errors ??
        err.response?.data?.error ??
        err.message;

      responseMessage = { status: err.status, message: errorResponse };
    }
    if (onError) {
      onError(errorResponse);
    }
  } finally {
    setLoading && setLoading(false);

    return idReturn
      ? { ...responseMessage, user_id: responseId || responseMessage.user_id }
      : responseMessage;
  }
};

export const getUploadStatus = async (request: string, totalUsers: number) => {
  const deleteUrl = `${apiPrefix}/user/status?request_id=${request}&total_users=${totalUsers}`;

  let response;

  response = await api.get(deleteUrl);

  return response;
};
